import "../polyfills/abort";
import { Toaster } from "@newsela/angelou";
import Head from "next/head";
import PropTypes from "prop-types";

import AllPagesWrapper from "@/base/AllPagesWrapper";
import { TOASTER_Z_INDEX } from "@/base/base.constants";
import globalToasterRef from "@/base/globalToasterRef";
import InternalToolingPanel from "@/base/InternalToolingPanel";
import RootProviders from "@/base/RootProviders";

const propTypes = {
  Component: PropTypes.elementType,
  pageProps: PropTypes.shape({
    [RootProviders.InitialPropsName]: PropTypes.shape(RootProviders.propTypes),
    dehydratedState: PropTypes.object,
  }),
};

const NewselaApp = ({ Component, pageProps }) => {
  return (
    <RootProviders
      {...pageProps[RootProviders.InitialPropsName]}
      dehydratedState={pageProps?.dehydratedState}
    >
      <Head>
        <title>Newsela | Instructional Content Platform</title>
        <meta
          name="description"
          content="Newsela is an Instructional Content Platform that supercharges reading engagement and learning in every subject."
        />
      </Head>
      <AllPagesWrapper>
        {/*
         * We render the `Toaster` at the top of the DOM, so that the landmark
         * is quick to find via screenreader.
         */}
        <Toaster
          ref={globalToasterRef}
          __cssFor={{
            root: {
              zIndex: TOASTER_Z_INDEX,
            },
          }}
        />
        <Component {...pageProps} />
      </AllPagesWrapper>
      <InternalToolingPanel />
    </RootProviders>
  );
};

NewselaApp.propTypes = propTypes;

export default NewselaApp;
